var _path, _path2, _path3, _linearGradient, _path4, _linearGradient2, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlutter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "flutter",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#42A5F5",
    fillOpacity: 0.8,
    d: "m6 15.695-3.696-3.696L14.305 0h7.391L6 15.695zm15.695-4.622h-7.391l-2.768 2.768 3.696 3.696 6.463-6.464z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0D47A1",
    d: "M11.536 21.232 14.305 24h7.391l-6.463-6.463-3.697 3.695z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A5F5",
    d: "m7.849 17.539 3.69-3.691 3.69 3.69-3.69 3.691-3.69-3.69z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -2075.633,
    x2: -2075.633,
    y1: -1590.528,
    y2: -1590.518,
    gradientTransform: "matrix(380.4042 -380.4175 53.104 53.1021 874056.25 -705127.375)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#616161",
    stopOpacity: 0.01
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "m11.539 21.229 3.69-3.69.515.515-3.69 3.69-.515-.515z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -2078.999,
    x2: -2078.99,
    y1: -1580.155,
    y2: -1580.155,
    gradientTransform: "matrix(565.291 0 0 380.9571 1175251.25 601990.813)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#616161",
    stopOpacity: 0.01
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "m11.536 21.232 5.483-1.894-1.788-1.801-3.695 3.695z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutter);
export default __webpack_public_path__ + "static/media/flutter.80d809615796f218e375cedbdbb79891.svg";
export { ForwardRef as ReactComponent };